import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import LaderImg from "../../assets/Loader.gif";
import "../../styles/Layout/_Backdrop.scss";

export default function BackdropHan(props) {
  const { open, handleClose } = props;
  return (
    <div className="backdrop">
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
        onClick={handleClose}
        className="backdrop-back"
      >
        <div className="backdrop-img">
          <img src={LaderImg} alt="" />
        </div>
      </Backdrop>
    </div>
  );
}
